<div class="title">
  <span fiTranslation="REQUEST_DETAIL_ADDITONAL_ADDRESS"></span>
  @if (contactForm) {
    <fi-checkbox class="checkbox" [(ngModel)]="sameAsContactAddress" (checkedChange)="onSameAsContactAddressChange()">
      <span class="text" fiTranslation="REQUEST_CREATE_SAME_CONSTUCTION_ADDRESS"></span>
    </fi-checkbox>
  }
</div>

<div class="address-fields" [formGroup]="form">

  <div class="form-field street-field">
    <fi-input labelKey="REQUEST_DETAIL_HEADLINE_ADDRESS_PROJECT_NAME" [hasError]="form?.touched && form?.controls?.Commission?.invalid" [form]="form" controlName="Commission" class="form-input street"></fi-input>
  </div>
  <div class="form-field street-field">
    <fi-input labelKey="REQUEST_DETAIL_HEADLINE_ADDRESS" [readOnly]="sameAsContactAddress && !!contactForm" [hasError]="form?.touched && form?.controls?.Address?.invalid" [form]="form" controlName="Address" class="form-input street"></fi-input>
  </div>

  <div class="place-container">
    <div class="form-field postcode">
      <fi-input labelKey="REQUEST_CREATE_CONTACT_HEADLINE_ZIPCODE" [readOnly]="sameAsContactAddress && !!contactForm" [hasError]="form?.touched && form?.controls?.ZipCode?.invalid" [form]="form" controlName="ZipCode" class="form-input postcode"></fi-input>
    </div>

    <div class="form-field place">
      <fi-input labelKey="REQUEST_CREATE_CONTACT_HEADLINE_CITY" [readOnly]="sameAsContactAddress && !!contactForm" [hasError]="form?.touched && form?.controls?.City?.invalid" [form]="form" controlName="City" class="form-input place"></fi-input>
    </div>
  </div>

  <div class="form-field country">
    <fi-input
      labelKey="REQUEST_CREATE_CONTACT_HEADLINE_COUNTRY"
      type="SELECT"
      [enableSearch]="true"
      [placeholderKey]="'REQUEST_DETAIL_EDIT_HEADER_COUNTRY_PLACEHOLDER'"
      (onChange)="onCountryChange($event)"
      [namePropertyPath]="'Name'"
      [valuePropertyPath]="'IsoCode'"
      [selectedOptionsOrValues]="form?.controls?.CountryCode?.value"
      [options]="resourceCountries"
      [readOnly]="sameAsContactAddress && !!contactForm"
    ></fi-input>
  </div>

  @if (provinceCountryCodes.includes(form?.controls?.CountryCode?.value)) {
    <div class="form-field province">
      <fi-input
        labelKey="REQUEST_CREATE_CONTACT_HEADLINE_PROVINCE"
        type="SELECT"
        [enableSearch]="true"
        [placeholderKey]="'REQUEST_DETAIL_EDIT_HEADER_PROVINCE_PLACEHOLDER'"
        (onChange)="form?.controls?.ProvinceCode?.setValue($event)"
        [namePropertyPath]="'Text'"
        [valuePropertyPath]="'Code'"
        [selectedOptionsOrValues]="form?.controls?.ProvinceCode?.value"
        [options]="resourceProvinces"
        [readOnly]="sameAsContactAddress && !!contactForm"
      ></fi-input>
    </div>
  }


  @if (leadDetails) {
    <div class="buttons" >
      <button class="submit-btn" (click)="onSubmit()">
        <img src="assets/icons/save-blue.svg" alt="save" class="icon" #save [isTitle] = "true" fiTranslation="ALT_TEXT_REQUEST_LIST_SAFE" matTooltip="{{save.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
        <span class="text" fiTranslation="BUTTON_ADDITIONAL_ADDRESS_SAVE"></span>
      </button>
      <button class="submit-btn" (click)="onDelete()">
        <img src="assets/icons/delete.svg" alt="delete" class="icon" #delete [isTitle] = "true" fiTranslation="ALT_TEXT_FILE_DELETE" matTooltip="{{delete.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
        <span class="text" fiTranslation="BUTTON_ADDITIONAL_ADDRESS_DELETE"></span>
      </button>
    </div>
  }

</div>
